export default function TaxDetails() {
  return (
    <div>
      <div className="government-bg bg-image">
        <div className="gap-spacer"></div>
        <div className="page-title top-cap-outlines">
          <h2>Tax Collection</h2>
        </div>

        {/*End Large Image Space*/}
        {/*Start Main Content*/}
        <div className="content-fluid">
          <div className="mb-960-center-container mid-side-outlines">
            {/*Full Width Element*/}
            <div className="mb-960-col-50p">
              <div className="left-right-padding-1em">
                <h4>Overview</h4>
                <p>
                  {" "}
                  The County and Borough real estate taxes cover the fiscal year
                  January 1 to December 31. Borough and County tax bills are
                  rendered on March 1. Real Estate tax is based on an assessed
                  valuation as determined by the Bucks County Board of
                  Assessment. Each entity of local government (County, School
                  District and Borough) sets its own tax rate.
                </p>

                <p>
                  School District taxes are issued on July 1st covering the
                  fiscal year July 1 to June 30. A 2% discount on all real
                  estate taxes is offered for payment made within 60 days of the
                  billing date and a 10% penalty is levied after 120 days from
                  the billing date.
                </p>

<h4>Tax Collector</h4>
<ul>
                  <li>Elected official</li>
                  <li>4 year term</li>
                  <li>Term expires first Monday in January</li>
                </ul>




              </div>
            </div>

            <div className="mb-960-col-50p">
              <div className="left-right-padding-1em">
                <h4>Current Tax Collector: Kathryn Schell</h4>
                <p>
                  Term Expires: January 2030
                  <br />
                  
                  <a href="mailto:katie0179@aol.com">
                    <i className="fa-solid fa-envelope"></i>
                    &nbsp;katie0179@aol.com
                  </a>
                  <br />
                  <a href="tel:9415254425">
                    <i className="fa-solid fa-phone"></i>&nbsp; 941-525-4425
                  </a>
                  <br />
                </p>
                <h4>
                  Office Location &amp; Hours
                  <br />
                  <a href="https://maps.app.goo.gl/RjUcQgXYQvFVtETj8">
                    <i className="fa-solid fa-location-pin"></i>&nbsp;Morrisville Borough Hall<br/>35 Union Street  Morrisville, PA 19067
                  </a>
                </h4>
                <p>
                <span className="red-bold-text">PLEASE NOTE: The Tax Collector has modified her posted hours.  We apologize for any inconvenience.</span>
                </p>
                <strong>July &amp; August</strong><br/>
                    <ul>
                        <li>Monday: 11:00 A.M. to 1:00 P.M.</li>
                        <li>Tuesday: 5:00 P.M. to 7:00 P.M.</li>
                        <li>Friday: 9:00 A.M. to 12:00 P.M.</li>
                    </ul>
                
                <p>
                  <b>There are no office hours in January or February</b>
                </p>
                <p><span className="italic-underline-text">Information updated: July 6, 2026</span></p>
              </div>
            </div>
          </div>
        </div>
        <div className="page-footer bottom-cap-outlines">&nbsp;</div>
        <div className="gap-spacer"></div>
        <div className="gap-spacer"></div>
        <div className="gap-spacer"></div>
        <div className="gap-spacer"></div>
        <div className="gap-spacer"></div>
        <div className="gap-spacer"></div>
        <div className="gap-spacer"></div>
        <div className="gap-spacer"></div>
        <div className="gap-spacer"></div>
        <div className="gap-spacer"></div>
      </div>
    </div>
  );
}
